import React, { useState, useEffect } from 'react';
import { Field } from 'redux-form';
import {
    consts as cfgConsts,
    selectors as cfgSelectors,
} from "../../../redux/modules/configuracoes";
import { compose } from 'redux';
import { connect } from "react-redux";
import { formataCampoRegionalizacao, validaCampoRegionalizacao } from '../../validation/regionalizacao';

const RegionalField = ({
  regionalizacaoConfig,
  campo,
  validate,
  normalize: customNormalize,
  format: customFormat,
  skipExtraValidate = false,
  skipNormalize = false,
  ...rest
}) => {
  const [newValidations, setNewValidations] = useState(validate);

  useEffect(() => {
    if (!skipExtraValidate && regionalizacaoConfig) {
      setNewValidations([
        ...(validate || []),
        ...(regionalizacaoConfig[campo] && regionalizacaoConfig[campo].validacoes
            ? validaCampoRegionalizacao(regionalizacaoConfig[campo].validacoes, campo)
            : []),
      ]);
    }
  }, [skipExtraValidate]);

  const resolvedNormalize = !skipNormalize && regionalizacaoConfig
    ? formataCampoRegionalizacao(regionalizacaoConfig[campo])
    : customNormalize || null;

  const resolvedFormat = !skipNormalize && regionalizacaoConfig
    ? formataCampoRegionalizacao(regionalizacaoConfig[campo])
    : customFormat || null;

  return (
    <Field
        normalize={resolvedNormalize}
        format={resolvedFormat}
        validate={newValidations}
        {...rest}
    />
  );
};

function mapStateToProps(state) {
  return {
    regionalizacaoConfig: cfgSelectors.getValorConfiguracao(
      state,
      cfgConsts.APPLICATION_STATIC_STRINGS,
    )['STATIC.COMMONS.CONFIG_REGIONALIZACAO'],
  };
};

export default compose(connect(mapStateToProps))(RegionalField);
